import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';

import { ResourcesService } from '../../../../services/resources/resources.service';
import { EventsService } from '../../../../services/events/events.service';

@Component({
  selector: 'modal-delete',
  styleUrls: [('./modalConfirm.scss')],
  templateUrl: './modalConfirm.html'
})

export class ModalConfirm {

  modalHeader: string;
  message: string ;
  exportDOW: boolean;

  withEvent: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private _notificationService: NotificationsService,
    private _resourcesService: ResourcesService,
    private _eventsService: EventsService) {
  }

  ngOnInit() { }

  closeModal() {
    this.activeModal.close();
  }

  doYes() {
    
    if (this.withEvent) {
      if (this.exportDOW === true) {
        this._eventsService.confirmExportDOWEvnt(false);
        console.log('expFileMadeDOW a1');      
      } else {
        this._eventsService.confirmExportPioneerEvnt(false);
        console.log('expFileMadeDOW a2');
      }     
    }
    this.activeModal.close();
  }

  doNo() {
    if (this.withEvent) {
      if (this.exportDOW === true) {
        // this._eventsService.confirmExportDOWEvnt(false);
        console.log('expFileMadeDOW b1 - NO');
      } else {
        // this._eventsService.confirmExportPioneerEvnt(false);
        console.log('expFileMadeDOW b2 - NO');
      }
    }
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalConfirm/modalConfirm.component.ts